<div class="create-request-container d-flex" [ngClass]="{ browserMenuBar: iOSBrowser && mobileSize }" *ngIf="stepNum$ | async as stepNum">
    <ng-container *ngIf="stepNum === 3 && !slotsLoaded$">
        <edp-loader [size]="'md'" [position]="'center'"></edp-loader>
    </ng-container>
    <create-request-sidebar class="sidebar"></create-request-sidebar>
    <div class="create-request-content d-flex w-100 flex-grow-1">
        <div class="steps-container w-100">
            <div *ngIf="!isNoAgreement" class="d-none d-wdgt-inline">
                <div class="clearfix text-right">
                    <button class="btn btn-close" (click)="dismissModal()" type="button">
                        <i class="icon icon-edponline-Bop-071 icon-2x" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="create-request-scroll" [ngClass]="{ 'step-faq': selfcare || (selfcare && stepNum !== 1), 'h-100': (isPage$ | async) }">
                <ng-container [ngSwitch]="stepNum">
                    <create-request-first-step class="step" *ngSwitchCase="1"></create-request-first-step>
                    <ng-container *ngSwitchCase="2">
                        <create-request-second-step
                            *ngIf="!isPaymentAgreementRequest && !loadingStepTwo"
                            class="step"
                            (closeModal)="closeModal()"
                            (backStep)="backStep()"
                        ></create-request-second-step>
                        <ng-container *ngIf="isPaymentAgreementRequest && !loadingStepTwo">
                            <edp-payment-agreement></edp-payment-agreement>
                        </ng-container>
                    </ng-container>
                    <create-request-datepicker class="step" [(selectedSlot)]="selectedSlot" *ngSwitchCase="3"></create-request-datepicker>
                </ng-container>
            </div>
            <ng-container
                *ngTemplateOutlet="
                    advanceButton;
                    context: {
                        showButton: !mobileSize,
                        stepNum: stepNum
                    }
                "
            ></ng-container>
        </div>
    </div>
    <ng-container
        *ngTemplateOutlet="
            advanceButton;
            context: {
                showButton: mobileSize,
                stepNum: stepNum
            }
        "
    ></ng-container>
</div>

<ng-template #advanceButton let-showButton="showButton" let-stepNum="stepNum">
    <ng-container *ngIf="showButton">
        <div class="create-request-advance mt-auto px-3 px-lg-0 pb-4-sa" *ngIf="stepNum !== 2">
            <button
                class="btn btn-primary"
                [disabled]="(advanceButtonDisabled$ | async) === false"
                (click)="moveStep()"
                [ngClass]="{ 'first-step': stepNum === 1 }"
            >
                <span class="create-request-advance-button-text px-4">
                    {{ "pt.edp.edponline.resquests-and-operations.advance" | translate }}
                </span>
            </button>
        </div>
    </ng-container>
</ng-template>
<div class="create-request-container-recaptcha-wrapper">
    <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
</div>
